import { useEffect } from "react";
import { Layout } from "antd";
import LogoIcon from "../../assets/icons/latest_vivo_logo.svg?react";
import authService from "../../services/authService";
import Loader from "../../components/UI/Loader";

const { Header, Content } = Layout;

/**
 * Login component that redirects to the external IAM service
 * If a user lands on this page, they will be automatically redirected to the IAM login
 */
export default function Login() {
  useEffect(() => {
    const checkAuthAndRedirect = async (): Promise<void> => {
      // Check for authorization code in URL (returning from IAM)
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get("code");

      if (code) {
        // Exchange code for tokens
        const result = await authService.exchangeCodeForTokens(code);

        if (result.success) {
          // Remove code from URL and redirect to dashboard
          window.location.replace("/dashboard");
          return;
        }
      }

      // Check if already authenticated
      const { authenticated } = await authService.isAuthenticated();

      if (authenticated) {
        // Already authenticated, redirect to dashboard
        window.location.replace("/dashboard");
        return;
      }

      // Not authenticated, redirect to IAM login
      // Use home as the return URL so user lands there after IAM login
      authService.redirectToIAMLogin(window.location.origin + "/dashboard");
    };

    checkAuthAndRedirect();
  }, []);

  // Show loading screen while redirecting
  return (
    <Layout className="main-auth-container">
      <Header className="header-auth-container">
        <LogoIcon className="mt-[30px]" />
      </Header>
      <Content className="content-auth-container">
        <div className="flex flex-col justify-center items-center h-screen">
          <Loader type="white" />
          <p className="text-white mt-4">Redirecting to login...</p>
        </div>
      </Content>
    </Layout>
  );
}
